import {
  History,
  LocationDescriptor,
  LocationDescriptorObject,
} from 'history';

function getLocationDescriptorObject(location: LocationDescriptor): LocationDescriptorObject {
  if (typeof location !== 'string') return location;
  const url = new URL(window.location.origin + location);
  return {
    pathname: url.pathname,
    search: url.search,
    hash: url.hash,
  };
}

export function enhanceHistoryPersistQuery(
  history: History,
  persistQueryList: string[],
): History {
  function persistQuery(location: LocationDescriptor): LocationDescriptor {
    const currentSearch = new URLSearchParams(history.location.search);
    const descriptor = getLocationDescriptorObject(location);
    const search = new URLSearchParams(descriptor.search);
    persistQueryList.forEach((key) => {
      const newValue = search.get(key);
      // if the value its `undefined` removes the key from the query params
      if (newValue === 'undefined') {
        search.delete(key);
        return;
      }

      if (currentSearch.has(key)) {
        const currentValue = currentSearch.get(key) as string;
        search.set(key, currentValue);
      }
    });
    descriptor.search = search.toString();
    return descriptor;
  }

  return {
    ...history,
    push: (location, state) => {
      history.push(persistQuery(location), state);
    },
    replace: (location, state) => {
      history.replace(persistQuery(location), state);
    },
  };
}
